import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren: function hasOneShowingChildren(children) {
      var showingChildren = children.filter(function (item) {
        return !item.hidden;
      });

      if (showingChildren.length === 1) {
        return true;
      }

      return false;
    }
  }
};